import {useStores} from "../../../stores/useStores";

export function useDirectoryUrl(): string | object | undefined {
    const {organizationStore} = useStores();

    let directoryUrl: string | undefined | object;
    if (organizationStore.currentOrganization.type === "collection") {
        directoryUrl = organizationStore.currentOrganization.url;
    } else if (
        organizationStore.currentOrganization.id === organizationStore.organization.id &&
        ["district", "organization"].includes(organizationStore.organization.type)
    ) {
        directoryUrl = {
            pathname: "/",
            query: {currentView: "directory"}
        }
    }

    return directoryUrl;
}